import { render, staticRenderFns } from "./IconHint.vue?vue&type=template&id=0c38d487&"
import script from "./IconHint.vue?vue&type=script&lang=js&"
export * from "./IconHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports